<template>
    <div class="col-md-9">
        <div class="tab-content">
            <overview :role="role" :project="currentProject"></overview>
            <change-orders :role="role" :user="user" :project="currentProject"></change-orders>
            <selections :role="role" :user="user" :project="currentProject"></selections>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['role', 'user', 'team'],

        created: function() {
            let vm = this;
            Bus.$on('set-current-project', function (project) {
                vm.currentProject = project;
                return true;
            });

            Bus.$on('refresh-current-project', function() {
                vm.refreshProject();
                return true;
            });
        },

        mounted: function() {

        },

        data: function() {
            return {
                currentProject: null
            };
        },

        computed: {
        },

        methods: {
            updateCurrentProject: function(project) {
                this.currentProject = project;
            },

            refreshProject: function() {
                axios.get('/api/projects/' + this.currentProject.id)
                    .then(response => {
                        this.updateCurrentProject(response.data);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }
    }
</script>
